module.exports = __webpack_public_path__ + "img/year_in_review.f69e1a3e.jpg";